import { render, staticRenderFns } from "./PeerGroupCard.vue?vue&type=template&id=b7fca898&scoped=true&"
import script from "./PeerGroupCard.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupCard.vue?vue&type=style&index=0&id=b7fca898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fca898",
  null
  
)

export default component.exports